"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _reactPopover = _interopRequireDefault(require("react-popover")),
    _draftJs = require("draft-js"),
    _classnames = _interopRequireDefault(require("classnames")),
    _CommentTextEditor = _interopRequireWildcard(require("../../CommentTextEditor"));

require("../styles/_add-comment.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var AddComment = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleUpdateContent = function (a) {
      d.setState({
        editorState: a
      });
    }, d.handleFilesChange = function (a) {
      d.setState({
        assetIds: a
      });
    }, d.getMetadata = function () {
      var a = d.props,
          b = a.metadata,
          c = a.filterByMetadataFlag;
      return void 0 === c ? JSON.stringify(b) : JSON.stringify(_objectSpread(_objectSpread({}, b), {}, (0, _defineProperty2["default"])({}, c.key, c.value)));
    }, d.handleSave = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.closePopover, e = b.createComment, f = b.onAddComment, g = d.state, h = g.editorState, i = g.assetIds, j = (0, _CommentTextEditor.getContentState)(h), k = j.json, l = j.plainText, l.trim()) {
                a.next = 5;
                break;
              }

              return a.abrupt("return");

            case 5:
              return d.setState({
                busy: !0
              }), a.next = 8, e({
                input: {
                  content: k,
                  metadata: d.getMetadata(),
                  assetIds: i
                }
              });

            case 8:
              if (m = a.sent, n = m.data, o = m.error, d.setState({
                busy: !1
              }), n && !o) {
                a.next = 14;
                break;
              }

              return a.abrupt("return");

            case 14:
              f && f(n), c();

            case 16:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.renderHeader = function () {
      var a = d.props,
          b = a.closePopover,
          c = a.getTitle;
      return _react["default"].createElement("div", {
        className: "comment-popover__header"
      }, _react["default"].createElement(_uiKit.Text, {
        heading3: !0,
        noMargin: "top"
      }, "Add Comment"), c ? _react["default"].createElement(_uiKit.Text, {
        heading5: !0
      }, c()) : null, _react["default"].createElement(_uiKit.Icon, {
        clickable: !0,
        className: "comment-popover__close-icon",
        name: "close",
        onClick: b,
        color: "regent",
        hoverColor: "black",
        size: 15
      }));
    }, d.renderBody = function () {
      var a = d.props.resourceOrganisationId,
          b = d.state,
          c = b.editorState,
          e = b.assetIds;
      return _react["default"].createElement("div", {
        className: "comment-popover__body"
      }, _react["default"].createElement(_CommentTextEditor["default"], {
        placeholder: "Enter comment",
        editorState: c,
        onUpdateContent: d.handleUpdateContent,
        onSave: d.handleSave,
        assetIds: e,
        onFilesChange: d.handleFilesChange,
        organisationId: a,
        canDeleteAsset: !0
      }));
    }, d.renderFooter = function () {
      var a = d.state,
          b = a.editorState,
          c = a.busy,
          e = (0, _CommentTextEditor.getContentState)(b),
          f = e.plainText;
      return _react["default"].createElement("div", {
        className: "comment-popover__footer"
      }, _react["default"].createElement(_uiKit.Button, {
        onClick: d.handleSave,
        type: "SECONDARY",
        busy: c,
        disabled: !f.trim()
      }, "Add Comment"));
    }, d.renderContent = function () {
      return _react["default"].createElement("div", {
        className: "comment-popover__container"
      }, d.renderHeader(), d.renderBody(), d.renderFooter());
    }, d.state = {
      editorState: _draftJs.EditorState.createEmpty(),
      busy: !1,
      assetIds: []
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.closePopover,
          d = a.appendTarget;
      return _react["default"].createElement(_reactPopover["default"], (0, _extends2["default"])({
        isOpen: !0,
        preferPlace: "right",
        enterExitTransitionDurationMs: 0,
        body: this.renderContent(),
        tipSize: .01,
        onOuterAction: c,
        className: (0, _classnames["default"])("comment-popover", "add-comment"),
        appendTarget: d
      }, this.props), b);
    }
  }]), b;
}(_react.Component),
    _default = AddComment;

exports["default"] = _default;